module.exports = __webpack_public_path__ + "img/bg-bottom-left.0ecee4ad.svg";